import React, { useMemo } from 'react';

import AnomalyNew from '../custom-visual-inspection/anomaly/anomaly-new';
import Conditional from '../../common/conditional';
import CustomSection from '../custom-general/custom-section';

import { getAnomalyId, getSplitData } from '../../../utils/utilities';
import { CoverDataItem, NewAnomalyItem } from '../../../utils/models';
import { MAX_ANOMALY_REPORT_PER_PAGE } from '../../../utils/constants';

interface CustomUTMAnomalyProps {
    anomalyItems: NewAnomalyItem[];
    lineNumberID: number;
    headers: CoverDataItem[];
    includePDO?: boolean;
    identifier?: string;
    sectionTitle?: string;
    sectionSubtitle?: string;
}

const CustomUTMAnomaly: React.FC<CustomUTMAnomalyProps> = ({ anomalyItems, lineNumberID, headers, identifier, includePDO = false, sectionSubtitle, sectionTitle = "Anomaly Report",  }) => {
    const anomalyItemsWithIndex = useMemo(() => {
        return anomalyItems.map((anomaly, index) => ({ ...anomaly, anomalyId: getAnomalyId(lineNumberID, index + 1), anomalyIndex: index + 1 }));
    }, [anomalyItems, lineNumberID]);

    return ( 
        <Conditional isVisible={anomalyItemsWithIndex.length > 0}>
            {getSplitData(anomalyItemsWithIndex, MAX_ANOMALY_REPORT_PER_PAGE).map((items, index: number) => {
                const [first, second] = items.some((item) => item.closeImage.length > 1) ? getSplitData(items, 1) : [items];

                return (
                    <React.Fragment key={index}>
                        <CustomSection  sectionTitle={sectionTitle} sectionSubtitle={sectionSubtitle} identifier={identifier} subidentifier={first.map((item) => item.anomalyId).join(',')}>
                            <AnomalyNew
                                includePDO={includePDO}
                                lineNumberID={lineNumberID}
                                headers={headers}
                                data={first}
                            />
                        </CustomSection>

                        {second && (
                            <CustomSection sectionTitle={sectionTitle} sectionSubtitle={sectionSubtitle} identifier={identifier} subidentifier={second.map((item) => item.anomalyId).join(',')}>
                                <AnomalyNew
                                    includePDO={includePDO}
                                    lineNumberID={lineNumberID}
                                    headers={headers}
                                    data={second}
                                />
                            </CustomSection>
                        )}
                    </React.Fragment>
                );
            })}
        </Conditional>
     );
}
 
export default CustomUTMAnomaly;